import { Grid, makeStyles, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import TableHeader from '../../../components/table/TableHeader';
import { Skeleton } from '@material-ui/lab';
import TablePagination from '../../../components/table/Pagination';
import React, { useContext } from 'react';
import { CreditNotesListDataContext } from '../CreditNotesListDataContextProvider';
import CreditNotesRow from './CreditNotesRow';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  skeleton: {
    height: '200px',
  },
  main: {
    padding: theme.spacing(1),
  },
}));

export default function CreditNotesTable() {
  const { t } = useTranslation(['debitors', 'invoices', 'creditNotes']);
  const classes = useStyles();

  const context = useContext(CreditNotesListDataContext);
  const preColumns = !context.isPrefilteredForDebtor
    ? [
        {
          label: t('status'),
          id: 'state',
        },
        {
          label: t('customer'),
          id: 'debitor',
        },
      ]
    : [
        {
          label: t('status'),
          id: 'state',
        },
      ];

  const columns = preColumns.concat([
    {
      label: t('amount'),
      id: 'total',
    },
    {
      label: t('creationDate'),
      id: 'creationDate',
    },
    {
      label: t('invoices:documentNumber'),
      id: 'documentNumber',
    },
  ]);

  const initialLoad = !context.page && context.loading;
  const emptyResultList = !!context.page && context.creditNotes && context.creditNotes.length === 0;
  const emptyFilteredResultList = emptyResultList && context.filters?.used;

  return (
    <>
      {emptyResultList ? (
        <>
          {emptyFilteredResultList ? (
            <Typography style={{ marginTop: '40px' }}>{t('creditNotes:no results for your credit notes search')}</Typography>
          ) : (
            <Grid item xs={12} className={classes.main}>
              <MuiAlert elevation={6} variant="filled" severity="warning">
                {t('creditNotes:no credit notes yet')}
              </MuiAlert>
            </Grid>
          )}
        </>
      ) : (
        <>
          <TableContainer style={{ flex: '1 1 auto' }}>
            <Table>
              <TableHeader columns={columns} actions={true}></TableHeader>
              <TableBody>
                <>
                  {initialLoad && (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1}>
                        <Skeleton className={classes.skeleton} />
                      </TableCell>
                    </TableRow>
                  )}
                  {context.creditNotes?.map((creditNote, index) => (
                    <CreditNotesRow creditNote={creditNote} index={index} key={creditNote.id} />
                  ))}
                </>
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination transformPageSizeLabel={(pageSize) => t('pageSize', { pageSize: pageSize }) as string} />
        </>
      )}
    </>
  );
}
